import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import WidgetStandalone from "@/pages/WidgetStandalone";
import Landing from "@/pages/Landing";
import Statistik from "@/pages/Statistik";
import { Construction } from "lucide-react";

const Placeholder = ({ title }) => (
  <>
    <div className="al-content-header">
      <h1>{title}</h1>
      <div className="al-breadcrumb">
        <span>Start</span>
        <span>/</span>
        <span style={{ color: "#212529" }}>{title}</span>
      </div>
    </div>
    <div className="al-content">
      <div className="al-card">
        <div className="al-card-body" style={{ textAlign: "center", padding: "3rem 1rem", color: "#6c757d" }}>
          <Construction size={48} style={{ margin: "0 auto 1rem", color: "#0d6efd" }} />
          <h2 style={{ fontSize: "1.2rem", fontWeight: 600, color: "#212529" }}>In Arbeit</h2>
          <p>Dieser Bereich wird als Nächstes mit Details und echten Daten gefüllt.</p>
        </div>
      </div>
    </div>
  </>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/wiesbaden" element={<Navigate to="/widget?ssg=true" replace />} />
        <Route path="/widget" element={<WidgetStandalone />} />
        <Route path="/db" element={<Layout><Dashboard /></Layout>} />
        <Route path="/db/statistik" element={<Layout><Statistik /></Layout>} />
        <Route path="/einfahrterlaubnisse" element={<Layout><Placeholder title="Einfahrterlaubnisse" /></Layout>} />
        <Route path="/terrorsperren" element={<Layout><Placeholder title="Terrorsperren" /></Layout>} />
        <Route path="/einstellungen" element={<Layout><Placeholder title="Einstellungen" /></Layout>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
